import { login, logout, getInfo } from '@/api/login';
import { getToken, setToken, removeToken } from '@/utils/auth'
import { getSystemAttachmentUrl } from '@/api/system/config'
import Cookies from "js-cookie";

const user = {
  state: {
    token: getToken(),
    userName: '',
    userCode: '',
    hiId: '',
    hiName: '',
    uiCode: '',
    uiName: '',
    uiPhone: '',
    avatar: '',
    roles: [],
    permissions: [],
    bookName: '',
    nickName: '',
    baseRoutingUrl: '',
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    HI_ID: (state, hiId) => {
      state.hiId = hiId
    },
    HI_NAME: (state, hiName) => {
      state.hiName = hiName
    },
    SET_USERCODE: (state, userCode) => {
      state.userCode = userCode
    },
    SET_USERNAME: (state, userName) => {
      state.userName = userName
    },
    SET_PHONE: (state, phone) => {
      state.phone = phone
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions
    },
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      const username = userInfo.username.trim()
      const password = userInfo.password
      const phone = userInfo.phone
      return new Promise((resolve, reject) => {
        login(username, password, phone).then(res => {
          setToken(res.data.token)
          commit('SET_TOKEN', res.data.token)
          commit('HI_ID', res.data.hi_Id)
          commit('HI_NAME', res.data.hi_Name)
          commit('SET_USERCODE', res.data.ui_Code)
          commit('SET_USERNAME', res.data.ui_Name)
          commit('SET_PHONE', res.data.ui_Phone)
          Cookies.set("_Login_url", window.location.href);
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    // GetInfo({ commit, state }) {
    //   return new Promise((resolve, reject) => {
    //       resolve()
    //   })
    // },

    // // 获取用户信息
    // GetInfo({ commit, state }) {
    //   return new Promise((resolve, reject) => {
    //     getInfo(state.token).then(res => {
    //       const user = res.user
    //       //   const avatar = user.avatar == "" ? require("@/assets/images/profile.jpg") : process.env.VUE_APP_BASE_API + user.avatar;
    //       const avatar = "";
    //       if (res.roles && res.roles.length > 0) { // 验证返回的roles是否是一个非空数组
    //         commit('SET_ROLES', res.roles)
    //         commit('SET_PERMISSIONS', res.permissions)
    //       } else {
    //         commit('SET_ROLES', ['ROLE_DEFAULT'])
    //       }
    //       commit('HI_ID', user.hi_Id)
    //       commit('HI_NAME', user.hi_Name)
    //       commit('SET_USERCODE', user.ui_Code)
    //       commit('SET_USERNAME', user.ui_Name)
    //       commit('SET_PHONE', user.ui_Phone)
    //       //commit('SET_AVATAR', avatar)
    //
    //       getSystemAttachmentUrl().then((resp) => {
    //         commit('SET_baseRoutingUrl', resp.msg);
    //       });
    //       resolve(res)
    //     }).catch(error => {
    //       reject(error)
    //     })
    //   })
    // },

    // // 退出系统
    // LogOut({ commit, state }) {
    //   return new Promise((resolve, reject) => {
    //     logout(state.token).then(() => {
    //       commit('SET_TOKEN', '')
    //       commit('SET_ROLES', [])
    //       commit('SET_PERMISSIONS', [])
    //       removeToken()
    //       resolve()
    //     }).catch(error => {
    //       reject(error)
    //     })
    //   })
    // },

    // 前端 登出
    LogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        commit('SET_ROLES', [])
        commit('SET_PERMISSIONS', [])
        removeToken()
        resolve()
      })
    },

    // // 前端 登出
    // FedLogOut({ commit }) {
    //   return new Promise(resolve => {
    //     commit('SET_TOKEN', '')
    //     removeToken()
    //     resolve()
    //   })
    // },

    // 更新用户信息

  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js